import Config from "../Config/config";
import callWebService, {callTypes} from "../Networks/network";
import {
    GET_DROPDOWN_PROJECT_TYPES,
    CREATE_REFERRAL,
    APPROVE_REFERRAL,
    GET_REFERRAL_DETAILS,
    GET_REFERRAL_LIST,
    SITE_CALLING_LIST,
    SITE_CALLING_LOG,
    SITE_CALLING_FORM,
    SITE_CALLING_FILTERS
} from "./type";

export const getProjectTypes = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getDropdownProjectTypes}`,

    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_DROPDOWN_PROJECT_TYPES,
            payload: data.response,
        });
        return data.response.data;
    }
};

export const createNewReferral = (data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.post,
        data,
        `${Config.createReferral}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: CREATE_REFERRAL,
            payload: data.response,
        });
        return data.status;
    }
};

export const updateReferralStatus = (id,data) => async (dispatch) => {
    const res = await callWebService(
        callTypes.put,
        data,
        `${Config.approveReferral}/${id}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: APPROVE_REFERRAL,
            payload: data.response,
        });
        return data;
    }
};

export const viewReferralDetails = (id) => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        '',
        `${Config.getReferralDetails}/${id}`,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_REFERRAL_DETAILS,
            payload: data.response,
        });
        return data.response.data;
    }
};

export const getAllReferrals = (page=1,data,filterInputList=null,searchValue=null) => async (dispatch) => {
    // const status = filterInputList && filterInputList.length > 0 && filterInputList[0].status !== undefined ? {'status': filterInputList[0].status} : {};
    const search = searchValue && searchValue!='undefined' && searchValue!='' ? {'search': searchValue} : {};
    const filterParams = Array.isArray(filterInputList) && filterInputList.length > 0 ? filterInputList[0] : {};
    const queryParams = new URLSearchParams({ page, ...data , ...filterParams, ...search}).toString();
    const url = `${Config.getReferralList}?${queryParams}`;
    const res = await callWebService(
        callTypes.get,
        '',
        url,
    );
    
    if (res) {
        const { data } = res;
        dispatch({
            type: GET_REFERRAL_LIST,
            payload: data.response,
        });
        return data.response.data;
    }
};

export const getAccountsForCalling = (page = 1,filterInputList=null,searchValue=null) => async (dispatch) => {
    const status = filterInputList && filterInputList.length > 0
        ? {
            ...(filterInputList[0].city ? { 'city_id': filterInputList[0].city } : {}),
            ...(filterInputList[0].sales_manager ? { 'sales_manager_id': filterInputList[0].sales_manager } : {})
        }
        : {};

    const search = searchValue && searchValue !== 'undefined' && searchValue !== ''
        ? { 'search': searchValue }
        : {};
    const queryParams = new URLSearchParams({ page, ...status, ...search}).toString();
    const url = `${Config.getAccountsForCalling}?${queryParams}`;
    console.log(url)
    const res = await callWebService(
        callTypes.get,
        '',
        url,
    );
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_CALLING_LIST,
            payload: data.response.data,
        });
        return data.response.data;
    }
};

export const saveReferralCallForm = (data) => async (dispatch) => {
    const url = `${Config.saveReferralCallForm}`;
    const res = await callWebService(
        callTypes.post,
        data,
        url,
    );
    
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_CALLING_FORM,
            payload: data.status,
        });
        return data.status;
    }
};

export const getReferralCallLogs = (id) => async (dispatch) => {
    const url = `${Config.getReferralCallLogs}?account_id=${id}`;
    const res = await callWebService(
        callTypes.get,
        '',
        url,
    );
    
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_CALLING_LOG,
            payload: data.response,
        });
        return data.response.data;
    }
};
  
export const getSiteListingFilters = () => async (dispatch) => {
    const url = `${Config.getReferralCallFilters}`;
    const res = await callWebService(
        callTypes.get,
        '',
        url,
    );
    
    if (res) {
        const { data } = res;
        dispatch({
            type: SITE_CALLING_FILTERS,
            payload: data.response,
        });
        return data.response.data;
    }
};
